// Size guide popup: a <dialog> opened by the matching [data-sg-open] trigger.
// Shared by the Sky product section and the Sky featured product section.
if (!customElements.get('sky-size-guide')) {
  customElements.define(
    'sky-size-guide',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.onOpen = (event) => {
          event.preventDefault();
          this.open();
        };
        this.triggers = document.querySelectorAll(`[data-sg-open="${this.dataset.for}"]`);
        this.triggers.forEach((trigger) => trigger.addEventListener('click', this.onOpen));

        this.dialog.addEventListener('click', (event) => {
          // Backdrop = the dialog frame or the panel padding around the card.
          const target = event.target;
          if (target === this.dialog || target.hasAttribute?.('data-sg-backdrop') || target.closest('[data-sg-close]')) {
            this.close();
          }
        });
        // Escape: close through our own transition instead of the instant native dismiss.
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });
      }

      disconnectedCallback() {
        this.triggers?.forEach((trigger) => trigger.removeEventListener('click', this.onOpen));
        document.documentElement.removeAttribute('scroll-lock');
      }

      open() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        document.documentElement.setAttribute('scroll-lock', '');
        requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      }

      close() {
        if (!this.dialog.open) return;
        this.dialog.classList.remove('is-open');
        document.documentElement.removeAttribute('scroll-lock');
        const done = () => this.dialog.close();
        this.dialog.addEventListener('transitionend', done, { once: true });
        setTimeout(done, 400); // in case the transition never fires (reduced motion)
      }
    }
  );
}
